module.exports = __webpack_public_path__ + "static/amigos-background-dark-6c4e8dbd83a23b55b500490578e80676.svg";